document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mainImage = root.querySelector('#ProductMainImage');
    const zoomTrigger = root.querySelector('[data-image-zoom]');
    const zoomDialog = root.querySelector('[data-image-dialog]');
    if (zoomTrigger && zoomDialog && mainImage) {
      let previousOverflow = '';
      zoomTrigger.addEventListener('click', () => {
        const zoomImage = zoomDialog.querySelector('[data-zoom-image]');
        zoomImage.src = mainImage.currentSrc || mainImage.src;
        zoomImage.alt = mainImage.alt;
        previousOverflow = document.body.style.overflow;
        zoomDialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      zoomDialog.querySelector('[data-close-zoom]').addEventListener('click', () => zoomDialog.close());
      zoomDialog.addEventListener('click', (event) => { if (event.target === zoomDialog) zoomDialog.close(); });
      zoomDialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        zoomTrigger.focus();
      });
    }
    root.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.imageSrc;
        mainImage.srcset = '';
        mainImage.alt = button.dataset.imageAlt || mainImage.alt;
        root.querySelectorAll('[data-product-thumbnail]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const saleBadge = root.querySelector('[data-sale-badge]');
    const skuWrap = root.querySelector('[data-sku-wrap]');
    const sku = root.querySelector('[data-product-sku]');
    const stock = root.querySelector('[data-stock-status]');
    const addButton = root.querySelector('[data-main-add-to-cart]');
    const addLabel = root.querySelector('[data-add-to-cart-label]');
    const stickyButton = root.querySelector('[data-sticky-add-to-cart]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyBar = root.querySelector('[data-mobile-sticky-purchase]');
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');

    const updateVariant = () => {
      if (!select) return;
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      const isSale = option.dataset.sale === 'true';
      if (price) {
        price.textContent = option.dataset.price || '';
        price.classList.toggle('sale-price', isSale);
      }
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.classList.toggle('is-hidden', !isSale);
      }
      if (saleBadge) saleBadge.classList.toggle('is-hidden', !isSale);
      if (sku) sku.textContent = option.dataset.sku || '';
      if (skuWrap) skuWrap.classList.toggle('is-hidden', !(option.dataset.sku || ''));
      if (stock) {
        stock.textContent = available ? '● Available to order' : '● Sold out';
        stock.classList.toggle('stock-status--in', available);
        stock.classList.toggle('stock-status--out', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
      if (stickyBar) stickyBar.dataset.unavailable = available ? 'false' : 'true';
      if (dynamicCheckout) dynamicCheckout.classList.toggle('is-hidden', !available);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url.toString());
    };
    if (select) select.addEventListener('change', updateVariant);

    if (stickyButton && addButton) stickyButton.addEventListener('click', () => addButton.click());
  });

  document.querySelectorAll('[data-filter-toggle]').forEach((toggle) => {
    const form = toggle.closest('.collection-controls');
    const panel = form && form.querySelector('[data-filter-panel]');
    if (!panel) return;
    toggle.addEventListener('click', () => {
      const open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form && select.form.submit());
  });

  document.querySelectorAll('product-recommendations[data-recommendations-url]').forEach((el) => {
    fetch(el.dataset.recommendationsUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('product-recommendations');
        if (replacement && replacement.innerHTML.trim().length) el.innerHTML = replacement.innerHTML;
      })
      .catch(() => {});
  });
});
